"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;
var React = _interopRequireWildcard(require("react"));
var _SliderUnstyled = _interopRequireWildcard(require("@mui/base/SliderUnstyled"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// https://mui.com/base/react-slider/
// https://mui.com/material-ui/api/slider/

const Slider = (0, _styledComponents.default)(_SliderUnstyled.default)`
    height: 4px;
    width: 100%;
    margin: 0 8px;
    padding-top: 10px;
    padding-bottom: 14px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    touch-action: none;
    -webkit-tap-highlight-color: transparent;

    &.${_SliderUnstyled.sliderUnstyledClasses.disabled} { 
        pointer-events: none;
        cursor: default;
        opacity: 0.5; 
    }

    & .${_SliderUnstyled.sliderUnstyledClasses.rail},
    & .${_SliderUnstyled.sliderUnstyledClasses.track} {
        display: block;
        position: absolute;
        width: 100%;
        height: 4px;
        border-radius: 2px;
        background-color: var(--input-bg-color);
        border: 1px solid var(--input-border-color);
    }

    & .${_SliderUnstyled.sliderUnstyledClasses.thumb} {
        position: absolute;
        width: 16px;
        height: 16px;
        margin-left: -8px;
        margin-top: -6px;
        box-sizing: border-box;
        border-radius: 50%;
        outline: 0;
        border: 1px solid var(--grey5);
        background-color: var(--bg-color);
    }
`;
exports.Slider = Slider;
Slider.propTypes = _SliderUnstyled.default.propTypes;